<template>
  <div
    :style="`width: ${getSliderWidth}px`"
    class="paginator-wrapper"
  >
    <div
      :class="{ slider: slidesForDevice >= dotCount }"
      :style="`transform: translateX(${translateX}px)`"
      class="dot-wrapper"
    >
      <div
        v-for="(item, index) in items.slice(0, slidesForDevice)"
        :key="item.id"
        :class="{ current: currentPage === index }"
        class="dot"
        @click="goToSlide(index)"
      ></div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      items: {
        type: Array,
        required: true
      },
      page: {
        type: Number,
        required: true
      },
      dotCount: {
        type: Number,
        default: 6
      },
      groupSlide: {
        type: Boolean,
        default: true
      }
    },

    data() {
      return {
        currentPage: 0,
        translateX: 0,
        navigateToSlide: 0,
        dotWidth: 36,
        lastDotMargin: 24
      }
    },

    computed: {
      ...mapGetters('device', ['isDesktop', 'isTablet', 'isMobile']),

      slidesForDevice() {
        let deviceSlideGroup
        let deviceSlide

        if (this.isMobile) {
          deviceSlideGroup = 1
          deviceSlide = 0

        } else if (this.isTablet) {
          deviceSlideGroup = 2
          deviceSlide = 1

        } else if (this.isDesktop) {
          deviceSlideGroup = 3
          deviceSlide = 2

        }

        if(!this.groupSlide) return this.items.length - deviceSlide


        return Math.ceil(this.items.length / deviceSlideGroup)
      },

      getSliderWidth() {
        return this.dotCount * this.dotWidth - this.lastDotMargin
      },
    },

    methods: {
      onSlideChange(page) {
        this.currentPage = page
        if (this.slidesForDevice > this.dotCount) {
          this.slideProgress()
        } else {
          this.translateX = 0
        }
      },

      slideProgress() {
        const endCursor = this.slidesForDevice - Math.ceil(this.dotCount / 2)
        const centerDotAlignFromEnd = Math.floor(this.dotCount / 2)

        if (this.currentPage <= 2) {
          this.translateX = 0
        }
        if (this.isPaginateEnd(endCursor)) {
          this.translateX = -(endCursor - centerDotAlignFromEnd) * this.dotWidth
        }
        if (this.currentPage >= 2 && !this.isPaginateEnd(endCursor)) {
          this.translateX = -(this.currentPage - 2) * this.dotWidth
        }
      },

      isPaginateEnd(endCursor) {
        return this.currentPage >= endCursor
      },

      goToSlide(slide) {
        this.$emit('paginatorNavigate', slide)
      }
    }
  }
</script>

<style
  lang="scss"
  scoped
>
  @import '~assets/styles/common.scss';

  .paginator-wrapper {
    display: flex;
    justify-content: center;
    width: 192px;
    overflow: hidden;
    margin: auto;
  }

  .dot-wrapper {
    display: flex;
    flex-direction: row;
    margin: 26px 0 auto 0;
    transition: all 0.5s ease-in-out;

    &.slider {
      width: 100%;

      .dot {
        margin-right: 24px;
        margin-left: 0;
      }
    }

    .dot {
      width: 12px;
      height: 12px;
      min-width: 12px;
      border-radius: 20px;
      background-color: rgba(21, 38, 73, 0.2);
      transition: all 0.5s ease-in-out;
      margin-right: 12px;
      margin-left: 12px;
      cursor: pointer;

      &.current {
        background-color: $blue-dark;
      }
    }
  }
</style>
